import {useCallback, useState} from 'react';
import {questionGenerateQuestionWithSeed} from '../../api/callable/question';

export interface GenerateQuestionWithSeedVariables {
  moduleId: string;
  topic?: string;
  seedQuestionId: string;
  variantCount?: number;
  numberOfVariants?: number;
  additionalInfo?: string;
}

export function useGenerateQuestionWithSeed() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | undefined>(undefined);

  const generateQuestionWithSeed = useCallback(async (variables: GenerateQuestionWithSeedVariables) => {
    const n = variables.numberOfVariants ?? variables.variantCount;
    if (typeof n !== 'number') {
      throw new Error('numberOfVariants or variantCount is required');
    }
    setLoading(true);
    setError(undefined);
    try {
      return await questionGenerateQuestionWithSeed({
        moduleId: variables.moduleId,
        seedQuestionId: variables.seedQuestionId,
        numberOfVariants: n,
        additionalInfo: variables.additionalInfo,
      });
    } catch (err) {
      const e = err instanceof Error ? err : new Error(String(err));
      setError(e);
      throw e;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    generateQuestionWithSeed,
    loading,
    error,
  };
}
